module.exports = __webpack_public_path__ + "static/media/coordenadaManual.a9fc053e.png";